import React from 'react';

/**
 * Overlay for a card whose `geo_ok` is false: a hint, never a gate (bkfc-cms discovery.md).
 * The card stays navigable; the detail/play routes answer GEO_BLOCKED on their own authority.
 */
const GeoUnavailable = () => (
  <div
    className="absolute z-20 bottom-2 left-2 px-2 py-1 text-xs font-semibold rounded-md bg-black/80 text-white"
    data-testid="geo-unavailable"
  >
    Not available in your region
  </div>
);

export default GeoUnavailable;
